import React from 'react';
import $ from "jquery"

class Collections extends React.Component {
    constructor(props) {
        super(props);
        var that = this;
        this.state = {
            selectedmenu: "earrings",
            mode: "mobile",
            //submenus: ["earrings", "chains", "bracelets", "rings"],
            submenus: ["earrings", "chains", "rings"],
            datadict: {
                "earrings": {
                    "caption": "Ohrringe",
                    "mainimage": "./assets/images/collections/earrings/IMG-20231117-WA0024.png",
                    "items": [
                        "./assets/images/collections/earrings/IMG-20231117-WA0000.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0045.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0001.png",

                        "./assets/images/collections/earrings/IMG-20231117-WA0020.png",
                        './assets/images/collections/earrings/IMG-20231117-WA0011.png',
                        "./assets/images/collections/earrings/IMG-20231117-WA0010.png",

                        "./assets/images/collections/earrings/IMG-20231117-WA0029.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0015.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0030.png",

                        "./assets/images/collections/earrings/IMG-20231117-WA0035.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0017.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0027.png",

                        "./assets/images/collections/earrings/IMG-20231117-WA0012.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0013.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0014.png",

                        "./assets/images/collections/earrings/IMG-20231117-WA0024.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0026.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0025.png",

                        "./assets/images/collections/earrings/IMG-20231117-WA0009.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0018.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0039.png",

                        "./assets/images/collections/earrings/IMG-20231117-WA0042.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0041.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0044.png",

                        "./assets/images/collections/earrings/IMG-20231117-WA0005.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0037.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0034.png",

                        "./assets/images/collections/earrings/IMG-20231117-WA0032.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0036.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0033.png",

                        "./assets/images/collections/earrings/IMG-20231117-WA0008.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0043.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0007.png",


                        "./assets/images/collections/earrings/IMG-20231117-WA0047.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0046.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0048.png",

                        "./assets/images/collections/earrings/IMG-20231117-WA0049.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0002.png",
                        "./assets/images/collections/earrings/IMG-20231117-WA0003.png"
                    ]
                },
                "chains": {
                    "caption": "Ketten",
                    "mainimage": "./assets/images/collections/chains/IMG-20231117-WA0066.png",
                    "items": [
                        "./assets/images/collections/chains/IMG-20231117-WA0067.png",
                        "./assets/images/collections/chains/IMG-20231117-WA0068.jpg",
                        "./assets/images/collections/chains/IMG-20231117-WA0069.jpg",

                        "./assets/images/collections/chains/IMG-20231117-WA0061.png",
                        "./assets/images/collections/chains/IMG-20231117-WA0062.jpg",
                        "./assets/images/collections/chains/IMG-20231117-WA0065.png",

                        "./assets/images/collections/chains/IMG-20231207-WA0000.png",
                        "./assets/images/collections/chains/IMG-20231207-WA0002.png",
                        "./assets/images/collections/chains/IMG-20231117-WA0063.png"
                    ]
                },
                // "bracelets": {
                //     "caption": "Armbänder",
                //     "mainimage": "./assets/images/collections/bracelets/bracelets1.png",
                //     "items": [
                //         "./assets/images/collections/bracelets/bracelets1.png",
                //         "./assets/images/collections/bracelets/bracelets2.png",
                //         "./assets/images/collections/bracelets/bracelets3.png",
                //         "./assets/images/collections/bracelets/bracelets4.png",
                //         "./assets/images/collections/bracelets/bracelets5.png",
                //         "./assets/images/collections/bracelets/bracelets6.png"
                //     ]
                // },
                "rings": {
                    "caption": "Ringe",
                    "mainimage": "./assets/images/collections/rings/IMG-20231117-WA0059.jpg",
                    "items": [

                        "./assets/images/collections/rings/_MG_4762.png",
                        "./assets/images/collections/rings/IMG_20181017_155632.png",
                        "./assets/images/collections/rings/IMG_20181017_155954.png",

                        "./assets/images/collections/rings/IMG-20231117-WA0053.jpg",
                        "./assets/images/collections/rings/IMG-20231117-WA0055.jpg",
                        "./assets/images/collections/rings/IMG-20231117-WA0054.jpg",

                        "./assets/images/collections/rings/IMG-20231117-WA0060.jpg",
                        "./assets/images/collections/rings/IMG-20231117-WA0052.jpg",
                        "./assets/images/collections/rings/IMG-20231117-WA0050.jpg",

                        "./assets/images/collections/rings/IMG-20231117-WA0057.jpg",
                        "./assets/images/collections/rings/IMG-20231117-WA0051.jpg",
                        "./assets/images/collections/rings/IMG-20231117-WA0058.jpg",

                    ]
                }
            }
        }
        $(window).resize(function () {
            that.resize();
        });
    }
    componentDidMount() {
        this.resize();
    }

    resize() {
        var that = this;
        if ($(window).width() > $(window).height()) {
            if (this.state && this.state.mode === 'mobile') {
                that.setState({
                    mode: 'web'
                });
            }
        }
        else {
            if (this.state && this.state.mode === 'web') {
                that.setState({
                    mode: 'mobile'
                });
            }
        }
    }

    changeContent = (index) => {
        this.setState({
            selectedmenu: index
        });
    };

    nextContent = () => {
        var currentindex = this.state.submenus.indexOf(this.state.selectedmenu);
        if (currentindex === this.state.submenus.length - 1) {
            this.setState({
                selectedmenu: this.state.submenus[0]
            });
        }
        else {
            this.setState({
                selectedmenu: this.state.submenus[currentindex + 1]
            });
        }
    };

    prevContent = () => {
        var currentindex = this.state.submenus.indexOf(this.state.selectedmenu);
        if (currentindex === 0) {
            this.setState({
                selectedmenu: this.state.submenus[this.state.submenus.length - 1]
            });
        }
        else {
            this.setState({
                selectedmenu: this.state.submenus[currentindex - 1]
            });
        }
    };

    render() {
        var that = this;
        var submenu = <div />;
        if (this.state.mode == 'web') {
            var list = (that.state.submenus.map(function (item) {
                return <div class='collections-submenu'>
                    <div class="floatrelative fullwidth">
                        <img src={that.state.datadict[item]["mainimage"]} class='collections-submenu-image center' onClick={() => that.changeContent(item)} />
                    </div>
                    <div class='menuitem text center fullwidth' onClick={() => that.changeContent(item)}> {that.state.datadict[item]["caption"]}</div> </div>
            }));
            submenu = <div class='collections-submenu-container fullwidthcontainer inlineblock'>
                {list}
            </div>
        }
        else {
            submenu = (<div class='collections-submenu-container fullwidthcontainer inlineblock centercontainer'>
                <div class='collections-submenu-navigation'>
                    <img src="./assets/arrow_left.png" class='collections-navigation-image center' onClick={() => that.prevContent()} />
                </div>
                <div class='collections-submenu-center'>
                    <img src={that.state.datadict[this.state.selectedmenu]["mainimage"]} class='collections-submenu-image center' />
                    <div class='collections-navigation-text text center fullwidth'> {that.state.datadict[this.state.selectedmenu]["caption"]}</div>
                </div>
                <div class='collections-submenu-navigation'>
                    <img src="./assets/arrow_left.png" class='collections-navigation-image center rotateimg180' onClick={() => that.nextContent()} />
                </div>
            </div >)
        }

        var list = (that.state.datadict[this.state.selectedmenu]["items"].map(function (item) {
            return <img src={item} class='smallimage' />;
        }));

        var collections = (
            <div class="fullwidth">
                {submenu}
                <div class="fullwidthcontainer">
                    {list}
                </div>
            </div>
        )
        return collections;
    }
}

export default (Collections);